import { twMerge } from "tailwind-merge"

const Heading6: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, children, ...props }) => {
  return (
    <h6 className={twMerge("font-extrabold text-[1.25rem] leading-[100%] md:leading-[100%]", className)} {...props}>
      {children}
    </h6>
  )
}

export default Heading6
